import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class LandingImageBlock extends BaseModel {
  static override constructorName = 'LandingImageBlock'

  readonly name = 'image_block'

  title: string = ''
  file: string = ''
  'is_background': boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['file', 'is_background'])

      this.file = toCroppedImage(data.file)
      this.is_background = Boolean(Number(data.is_background))
    }
  }
}
